
            export default {
              mounted() {
                this.el.addEventListener("click", () => {
                  if (this.el.disabled) return
                  if (!navigator.geolocation) {
                    this.pushEvent("capture_floor_alt", {ok: false, error: "unsupported"})
                    return
                  }
                  const original = this.el.textContent
                  this.el.disabled = true
                  this.el.textContent = "Waiting for GPS…"
                  navigator.geolocation.getCurrentPosition(
                    (pos) => {
                      const alt = pos.coords.altitude
                      const acc = pos.coords.altitudeAccuracy
                      this.pushEvent("capture_floor_alt", {
                        ok: Number.isFinite(alt),
                        altitude: alt,
                        accuracy: Number.isFinite(acc) ? acc : null,
                      })
                      this.el.disabled = false
                      this.el.textContent = original
                    },
                    (err) => {
                      this.pushEvent("capture_floor_alt", {ok: false, error: String(err.code)})
                      this.el.disabled = false
                      this.el.textContent = original
                    },
                    {enableHighAccuracy: true, timeout: 20000, maximumAge: 0}
                  )
                })
              }
            }
          